const DEFAULT_UNITS_LIST = {
	networkType: {
		code: '',
		name: '',
	},
	units: {
		unitsByLocality: [],
		unitsByDistance: [],
		unitsSupportAccredited: [],
	},
};
export {DEFAULT_UNITS_LIST};
